export const MAX_BOOKMARKS = 10
